import WhatsAppFAB from "./components/WhatsAppFAB";
import HomePage from "./pages/HomePage";

function App() {
  return (
    <div className="min-h-screen bg-background text-navy">
      {/* Grid — top fade (hidden on mobile to prevent GPU glitches) */}
      <div
        className="fixed inset-0 pointer-events-none hidden sm:block"
        style={{
          backgroundImage:
            "linear-gradient(to right, var(--grid-line-x) 1px, transparent 1px), linear-gradient(to bottom, var(--grid-line-y) 1px, transparent 1px)",
          backgroundSize: "320px 320px",
          maskImage:
            "radial-gradient(ellipse 80% 50% at 50% 0%, #000 70%, transparent 100%)",
          WebkitMaskImage:
            "radial-gradient(ellipse 80% 50% at 50% 0%, #000 70%, transparent 100%)",
        }}
      />
      {/* Grid — bottom fade (hidden on mobile to prevent GPU glitches) */}
      <div
        className="fixed inset-0 pointer-events-none hidden sm:block"
        style={{
          backgroundImage:
            "linear-gradient(to right, var(--grid-line-x) 1px, transparent 1px), linear-gradient(to bottom, var(--grid-line-y) 1px, transparent 1px)",
          backgroundSize: "320px 320px",
          maskImage:
            "radial-gradient(ellipse 80% 50% at 50% 100%, #000 70%, transparent 100%)",
          WebkitMaskImage:
            "radial-gradient(ellipse 80% 50% at 50% 100%, #000 70%, transparent 100%)",
        }}
      />
      {/* Glow blob — hidden on mobile to prevent GPU rendering glitches */}
      <div
        className="fixed pointer-events-none hidden sm:block"
        style={{
          top: "-200px",
          left: "50%",
          transform: "translateX(-50%)",
          width: "1000px",
          height: "1000px",
          borderRadius: "9999px",
          background: "var(--glow-blue)",
          opacity: 0.5,
          filter: "blur(100px)",
        }}
      />

      <HomePage />
      <WhatsAppFAB />
    </div>
  );
}

export default App;
